import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  Aangever,
  Aangifte, BokkzAlgDataService,
  BokkzIbDataService,
  Heffingskortingen,
  IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SPINNER_TIMEOUT} from "../gedeelde-componenten/gedeelde-componenten.component";


@Component({
    selector: 'snelstart-venture-fiscaal-feature-heffingskortingen',
    templateUrl: './heffingskortingen.component.html',
    styleUrls: ['./heffingskortingen.component.scss'],
})
export class HeffingskortingenComponent implements OnInit {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;



    public heffingskorting = this.fb.group(({
        ouderschapsverlofUrenOpgenomen: null as unknown as number,
        ouderschapsverlofBelastbaarLoonVorigJaar: null as unknown as number,
        ouderschapsverlofBelastbaarLoonTweeJaarGeleden: null as unknown as number,
        arbeidsInkomenPartner: null as unknown as number,
        verzamelInkomenPartner: null as unknown as number,
        geboortedatumPartner: undefined as unknown as Date,
        krijgtWajong: undefined as unknown as boolean,
        rechtOpAowAlleenstaande: undefined as unknown as boolean,
        levensloopVerlofGehad: undefined as unknown as boolean,
        levensloopverlofkortingToegepast: null as unknown as number,
        bedragVutUitkering: null as unknown as number,

    } as Heffingskortingen))

    get heffingskortingen(): FormGroup {
        return this.heffingskorting.get("heffingskortingen") as FormGroup;
    }

    constructor(private fb: FormBuilder, public dataService: BokkzIbDataService) {
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
            }
        });
    }

}
